import { defineStyleConfig } from '@chakra-ui/react';

const Checkbox = defineStyleConfig({
  baseStyle: (props) => ({
    control: {
      _checked: {
        bg: props.colorScheme === 'brand' ? 'brand.blue.500' : `${props.colorScheme}.500`,
        borderColor: props.colorScheme === 'brand' ? 'brand.blue.500' : `${props.colorScheme}.500`,
        _hover: {
            bg: props.colorScheme === 'brand' ? 'brand.blue.600' : `${props.colorScheme}.600`,
            borderColor: props.colorScheme === 'brand' ? 'brand.blue.600' : `${props.colorScheme}.600`,
        }
      },
    },
  }),
});

export default Checkbox;
